<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Manage Team Members</h2>
      <p class="project-name">{{ projectName() }}</p>
      <button class="close-btn" (click)="onClose()" aria-label="Close">×</button>
    </div>

    <div class="modal-body">
      @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
      }

      <div class="add-manager-section">
        <h3>Add Team Member</h3>
        <div class="add-manager-form">
          <select [(ngModel)]="selectedUserId" [disabled]="loading() || loadingUsers()" class="user-select">
            @if (loadingUsers()) {
            <option value="">Loading users from organization...</option>
            } @else {
            <option value="">Select a user...</option>
            @for (user of availableUsers(); track user.id) {
            <option [value]="user.id">
              {{ user.firstName || '' }} {{ user.name }} {{ user.email ? '(' + user.email + ')' : '' }}
            </option>
            }
            }
          </select>
          @if (loadingUsers()) {
          <div class="loading-spinner-inline">
            <svg class="spinner" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
          </div>
          } @else {
          <button (click)="addMember()" [disabled]="loading() || !selectedUserId" class="btn btn-member">
            {{ loading() ? 'Adding...' : 'Add Member' }}
          </button>
          }
        </div>
      </div>

      <div class="managers-section">
        <h3>Current Team Members ({{ visibleMembers.length }})</h3>
        @if (archivedMembersCount > 0) {
          <label class="archived-toggle" title="Archived members stay linked to the project but are hidden by default">
            <input type="checkbox" [(ngModel)]="showArchivedMembers">
            Show archived ({{ archivedMembersCount }})
          </label>
        }

        @if (loading() && members().length === 0) {
        <div class="loading">Loading members...</div>
        }

        @if (!loading() && visibleMembers.length === 0) {
        <div class="empty-state">
          <p>No team members assigned to this project yet.</p>
        </div>
        }

        @if (visibleMembers.length > 0) {
        <div class="managers-list">
          @for (member of visibleMembers; track member.id) {
          <div class="manager-item" [class.manager-item--archived]="member.user?.isArchived">
            <div class="manager-info">
              <div class="manager-avatar">{{ getMemberDisplayName(member).charAt(0).toUpperCase() }}</div>
              <div class="manager-details">
                <div class="manager-name">{{ getMemberDisplayName(member) }}</div>
                @if (member.user && member.user.email) {
                <div class="manager-email">{{ member.user.email }}</div>
                }
              </div>
              <!-- Role badge -->
              <span class="role-badge role-badge--member">Member</span>
              @if (member.user?.isArchived) {
              <span class="role-badge role-badge--archived">Archived</span>
              }
            </div>
            <button (click)="removeMember(member.id!)" [disabled]="loading()" class="btn btn-danger btn-sm"
              title="Remove member">
              Remove
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button (click)="onClose()" class="btn btn-secondary">Close</button>
    </div>
  </div>
</div>